<template>
  <div>
    <h1>GEORGIA DEFENSE EXCHANGE (GDX) ADMINISTRATION MODULE TUTORIALS</h1>
    <p>Please use the links below to watch step-by-step tutorials on how to use the Administration Module in the Georgia Defense Exchange</p>
    <v-expansion-panel focusable class="faq-list">
      <v-expansion-panel-content v-for="(item, index) in tutorials" :key="index">
        <h3 slot="header" class="expansion-header">{{item.order}}. {{item.question}}</h3>
        <v-card class="faq-content">
          <v-card-text class="grey lighten-3">
            <img
              v-if="item.mediaType.length && item.mediaType === 'image'"
              class="faq-media"
              :src="item.media"
              style="float: left"
            >
            <iframe
              v-if="item.mediaType.length && item.mediaType === 'video'"
              :src="item.media.embedUrl"
            />
            <div class="faq-text" v-html="item.answer"></div>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$store.dispatch('getTutorials')
    const payload = {
      meta: {
        h1: 'Admin Tutorials',
        title: 'Admin Tutorials - All Tutorials',
        requiresAuth: true
      }
    }
    document.title = payload.meta.title
    this.$store.commit('setHeaderInfo', payload)
  },
  computed: {
    tutorials () {
      return this.$store.getters.tutorials.sort((a, b) => a.order - b.order)
    }
  }
}
</script>

<style lang="scss">
.expansion-panel__header {
  height: 94px;
  .expansion-header {
    font-weight: 400;
    color: #585858;
  }
  .header__icon i {
    font-size: 47px;
  }
}
.faq-list {
  .faq-content {
    iframe {
      width: 500px;
      height: 300px;
      border: none;
      margin: 0 20px 20px 0;
      float: left;
    }
    img {
      max-width: 500px;
      max-height: 300px;
      border: none;
      margin: 0 20px 20px 0;
      float: left;
    }
    .faq-text {
      font-size: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// AllTutorials.vue?53a4aac2